import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { SlickCarouselComponent } from 'ngx-slick-carousel';

@Component({
  selector: 'app-cash-rewards-carousel',
  templateUrl: './cash-rewards-carousel.component.html',
  styleUrls: ['./cash-rewards-carousel.component.scss']
})
export class CashRewardsCarouselComponent implements OnInit {
  @ViewChild('slickModalBanner') slickModalBanner!: SlickCarouselComponent;
  @Output() onLastSlideReached = new EventEmitter<void>();

  currentIndex: number = 0;
  imageUrlArray: any = [
    'https://sellerrewards-datahandler.cisco.com/shared/files/sr-pointscash-1.png',
    'https://sellerrewards-datahandler.cisco.com/shared/files/sr-pointscash-2.png',
    'https://sellerrewards-datahandler.cisco.com/shared/files/sr-pointscash-3.png',
    'https://sellerrewards-datahandler.cisco.com/shared/files/sr-pointscash-4.png',
    'https://sellerrewards-datahandler.cisco.com/shared/files/sr-pointscash-5.png',
  ];

  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: false,
  };

  ngOnInit() {
  }

  sliderChange(event: any) {
    this.currentIndex = event.currentSlide;
  }

  goToPrev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.slickModalBanner.slickGoTo(this.currentIndex);
    }
  }

  goToNext() {
    if (this.currentIndex < this.imageUrlArray.length - 1) {
      this.currentIndex++;
      this.slickModalBanner.slickGoTo(this.currentIndex);
    }
    if (this.currentIndex === this.imageUrlArray.length - 1) {
      this.onLastSlideReached.emit();
    }
  }

  resetCarousel() {
    this.currentIndex = 0;
    if (this.slickModalBanner) {
      this.slickModalBanner.slickGoTo(this.currentIndex);
    }
  }
}
